<template>
  <div style="position:relative;">
      <div :class="cls">
          <span class="text-con" ><span v-html="data"></span><span class="text-hidden" v-show="flag == 1" @click.stop.prevent="hide">{{tit2}}<svg-icon class="icon"  icon-class="arrow_up" /></span></span>
      </div>
        <span class="text-open" v-show="flag == 2"  @click.stop.prevent="open">...<span>{{tit1}}<svg-icon class="icon"  icon-class="arrow_down" /></span></span>
  </div>
</template>

<script>
export default {
  name: 'textmore',
  props:{
    height:{
      type: Number,
      default: 50
    },
    data: {
      type: String,
      default: ''
    },
    tit1:{
      type: String,
      default: '展开'
    },
    tit2:{
      type: String,
      default: '收起'
    }
  },
  data(){
      return{
        flag: 0, //标记 0：为数据少，1：数据收起，2：数据展开
        cls: '',
      }
  },
  watch: {
    data: {
      handler (newVal, oldVal) {
        this.$nextTick(() => {
          let n = document.querySelector(`.text${this._uid} .text-con`)
          if (n.clientHeight > this.height) {
            this.flag = 2
            n.setAttribute('style', `height:${this.height}px;overflow:hidden`)
          } else {
            this.flag = 0
            n.setAttribute('style', '')
          }
        })
      },
      immediate:true
    }
  },
 
  created () {
    this.cls = `text-ellipse text${this._uid}`
  },
  methods: {
    open () {
      this.flag = 1
      document.querySelector(`.text${this._uid} .text-con`).setAttribute('style', '')
      this.$emit('changeOpen', true)
    },
    hide () {
      this.flag = 2
      document.querySelector(`.text${this._uid} .text-con`).setAttribute('style', `height:${this.height}px;overflow:hidden`)
      this.$emit('changeOpen', false)
    },
  },
  }
</script>

<style scoped>
.text-ellipse {
  position:relative;
  width: 100%;
  }
.text-con {
  display:inline-block;
  width: 100%;
}
.text-open{
    position: absolute;
    right: 0;
    bottom: 6px;
    background: #fff;
    z-index: 2;
    line-height: 24px;
    padding-left: 3px;
    
    cursor:pointer;
}
.text-open > span{
  color:#5167EF;
  padding-left: 6px;
}
.text-open > span:hover{
  background: #E7F9F6;
}
.icon{
  margin-right:5px;
  color: #5167EF;
  stroke:#5167EF;
}
.text-hidden {
  color: #5167EF;
  float:right;
  cursor:pointer;
  text-align: center;
  padding-left: 20px;
}
.text-hidden:hover{
  background: #E7F9F6;
}
</style>
